import {
  TROVIT_NEWSLETTERS,
  PARTNERS_NEWSLETTERS,
} from '../../../NotificationsManager/email/NewsletterNotifications/constants';

const newsletterTypeMap = {
  [TROVIT_NEWSLETTERS]: 'terceros',
  [PARTNERS_NEWSLETTERS]: 'partners',
};

export function mapNewsletterActivityStatusToRequest({ type, active }) {
  return {
    newsletterType: newsletterTypeMap[type],
    operation: active ? 'enabled' : 'disabled',
  };
}



// WEBPACK FOOTER //
// ./app/sdk/notifications/email/notificationsAdapter.js